// src/components/ui/Checkbox.tsx
import React from "react";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  error?: string;
};

export default function Checkbox({ label, error, className, ...props }: Props) {
  return (
    <div className="block">
      <label className="flex items-center gap-2 text-sm">
        <input
          {...props}
          type="checkbox"
          className={`h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-slate-400 ${
            className ?? ""
          }`}
        />
        <span className="text-slate-700">{label}</span>
      </label>
      {error ? <span className="mt-1 block text-xs text-red-600">{error}</span> : null}
    </div>
  );
}
